import * as React from 'react'

export const Why = () => {
  const data = [
    {
      title1: 'Professional team',
      title2: 'ทีมผู้เชี่ยวชาญ',
      icon: '/images/ai/why/icon1.svg',
      description:
        'เรามีความพร้อมที่จะช่วยพัฒนาให้ธุรกิจของคุณเติบโตไปพร้อม ๆ กับเรา เสมือนเป็นคู่ค้าที่เข้าใจกัน และเดินหน้าไปด้วยกัน',
    },
    {
      title1: 'ISO certified',
      title2: 'ข้อมูลปลอดภัย',
      icon: '/images/ai/why/icon2.svg',
      description:
        'การทำโปรเจค AI ต้องใช้ข้อมูลจำนวนมาก ไร้ปัญหาข้อมูลรั่วไหล หรือ เครื่องมือไม่ได้มาตรฐานเพราะเราให้ความสำคัญกับการรักษาข้อมูลส่วนนี้เป็นอย่างมาก',
    },
    {
      title1: 'Cutting-edge technology',
      title2: 'พัฒนาเทคโนโลยีใหม่ๆเสมอ',
      icon: '/images/ai/why/icon3.svg',
      description:
        'เราศึกษางานวิจัยอยู่เสมอ และพัฒนาอยู่ตลอดเวลา ลูกค้าสามารถรับข้อมูลเบื้องหลังของเทคโนโลยีที่เราใช้ได้ เพื่อนำไปต่อยอดไอเดียของโปรดักส์',
    },
    {
      title1: 'Flexibility',
      title2: 'พร้อมปรับทุกความต้องการ',
      icon: '/images/ai/why/icon4.svg',
      description:
        'เพราะความปรารถนาของลูกค้ามาก่อนเสมอ ทีมผู้เชี่ยวชาญของเราพร้อมให้คำปรึกษา และหาโซลูชันมาแก้ไขปัญหาให้กับทุกๆความต้องการลูกค้า',
    },
  ]

  return (
    <div className='AI__why'>
      <header className='AI__why__header'>
        <div className='container'>
          <h3>เพราะธุรกิจต้องการคนที่เข้าใจ</h3>
          <p>
            เรามีความพร้อมที่จะช่วยพัฒนาให้ธุรกิจของคุณเติบโตไปพร้อม ๆ กับเรา
            เสมือนเป็นคู่ค้าที่เข้าใจกัน และเดินหน้าไปด้วยกัน
          </p>
        </div>
      </header>

      <div className='AI__why__content'>
        <div className='container'>
          <ul className='AI__why__list'>
            {data.map((item, index) => {
              return (
                <li key={index} className='AI__why__item'>
                  <div>
                    <span>{index + 1}</span>
                    <h5>
                      <small>{item.title1}</small>
                      {item.title2}
                    </h5>
                    <img src={item.icon} alt='Icon' />
                  </div>

                  <p>{item.description}</p>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}
